import { LocalAccountSigner } from "@aa-sdk/core";
import {
  userSmartAccount,
  userSmartAccountClient,
} from "../components/recoilAtom";
import { useRecoilValue } from "recoil";
import { getIndexKey, saveIndexKey } from "../components/indexDb";
import { generatePrivateKey, privateKeyToAccount } from "viem/accounts";
import { ACTIVE_SESSION_TIME } from "../utils/Enviroment";
import { isMobile } from "react-device-detect";

export const useSessionPermissions = () => {
  const smartAccountClient = useRecoilValue(userSmartAccountClient);
  const smartAccount = useRecoilValue(userSmartAccount);

  const grantPermissions = async () => {
    if (smartAccountClient && smartAccount) {
      try {
        const currentTime = Math.floor(Date.now() / 1000);
        const sessionExpiryTime = Number(
          localStorage.getItem("sessionExpiryTime") ?? 0
        );
        const smartAccountss = localStorage.getItem("smartAccount");
        // const stored = await getIndexKey('sessionKeyData');
        const stored = JSON.parse(localStorage.getItem("sessionKeyData"));
        const isSessionValid =
          currentTime >= sessionExpiryTime ||
          !stored ||
          smartAccountss != smartAccount;
        if (isSessionValid) {
          console.log("Session has expired, granting new permissions");
          localStorage.removeItem("sessionKeyData");
          localStorage.removeItem("sessionExpiryTime");
          const sessionTime = ACTIVE_SESSION_TIME;
          const privateKey = generatePrivateKey();
          const account = privateKeyToAccount(privateKey);
          const sessionKey = new LocalAccountSigner(account);
          const permissions = await smartAccountClient?.grantPermissions({
            account: smartAccount,
            expirySec: sessionTime,
            key: {
              publicKey: await sessionKey?.getAddress(),
              type: "secp256k1",
            },
            permissions: [{ type: "root" }],
          });
          localStorage.setItem("sessionExpiryTime", sessionTime);
          localStorage.setItem("smartAccount", smartAccount);
          const sessionKeyData = {
            privateKey,
            permissions,
          };
          localStorage.setItem(
            "sessionKeyData",
            JSON.stringify(sessionKeyData)
          );
          // await saveIndexKey('sessionKeyData', sessionKeyData);
          return {
            userPermissions: permissions,
            userSessionKey: sessionKey,
            isMobile: isMobile,
          };
        } else {
          const account = privateKeyToAccount(stored.privateKey);
          const sessionKey = new LocalAccountSigner(account);
          const grantedPermissions = stored.permissions;
          const grantedSessionKey = sessionKey;
          return {
            userPermissions: grantedPermissions,
            userSessionKey: grantedSessionKey,
          };
        }
      } catch (error) {
        console.error("Error granting permissions:", error);
      }
    } else {
      console.log("smartAccountClient or smartAccount is not ready yet");
    }
  };

  return { grantPermissions };
};
